import { ThemeProvider } from '@emotion/react';
import { AlgoliaSearchInstant } from 'common-ui';
import HeaderFooterWrapper from './HeaderFooterWrapper';
import type { CommonEmbeddedHeaderFooterAppProps } from 'tsconfig/types';
import { AppInitEmbedded } from './AppInitEmbedded';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';

export function CommonEmbeddedHeaderFooterApp({ theme, GlobalStyles }: CommonEmbeddedHeaderFooterAppProps) {
  return (
    <MantineProvider withNormalizeCSS withGlobalStyles>
      <Notifications position="top-right" />
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <AppInitEmbedded />
        <AlgoliaSearchInstant>
          <HeaderFooterWrapper config={window.newHeaderFooterInitData || {}} />
        </AlgoliaSearchInstant>
      </ThemeProvider>
    </MantineProvider>
  );
}
